var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 12,
    height: 12,
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2476_22390",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 12,
    height: 12
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 12,
    height: 12,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2476_22390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8.02348C11.2235 8.02348 11 8.24795 11 8.52443V12.5323C11 12.8083 10.776 13.0332 10.5 13.0332H3.5C3.22397 13.0332 3.00003 12.8083 3.00003 12.5323V5.51856C3.00003 5.24254 3.22397 5.01761 3.5 5.01761H7.50003C7.77652 5.01761 8 4.79314 8 4.51666C8 4.24009 7.77652 4.01562 7.50003 4.01562H3.5C2.673 4.01562 2 4.68995 2 5.51856V12.5323C2 13.3609 2.673 14.0352 3.5 14.0352H10.5C11.327 14.0352 12 13.3609 12 12.5323V8.52443C12 8.2474 11.7765 8.02348 11.5 8.02348Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68806 7.5653C6.65309 7.60034 6.62956 7.64492 6.61958 7.69299L6.2661 9.46452C6.24962 9.54662 6.27562 9.63128 6.33458 9.69091C6.38209 9.73852 6.44609 9.76402 6.51164 9.76402C6.52757 9.76402 6.54414 9.76255 6.56062 9.75907L8.32814 9.40489C8.37712 9.3948 8.42161 9.37132 8.45613 9.33618L12.4121 5.37245L10.6446 3.60156L6.68806 7.5653Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6338 2.37807C13.1464 1.8896 12.3533 1.8896 11.8663 2.37807L11.1743 3.07138L12.9418 4.84236L13.6338 4.14896C13.8698 3.91302 13.9998 3.59838 13.9998 3.26374C13.9998 2.92911 13.8698 2.61447 13.6338 2.37807Z",
    fill: "#4D4D4D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditMenuIcon);
export default __webpack_public_path__ + "static/media/editMenuIcon.a31ab87f1bdbcb5927cc112b56d81277.svg";
export { ForwardRef as ReactComponent };